<template>
  <div class="layout">
    <HeaderAppDesktop />

    <!-- Page content -->
    <slot> </slot>

    <HeaderAppMobile v-if="!hideMobileMenu" />
    <Footer v-else />
  </div>
</template>

<script setup lang="ts">
import Footer from '@/app/components/Footer.vue'
import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderAppMobile from '@/app/components/header/AppMobile.vue'
import { onBeforeMount } from 'vue'

defineProps<{
  /**
   * Remove the header mobile menu (HeaderAppMobile)
   */
  hideMobileMenu?: boolean
}>()

onBeforeMount(async () => {
  // Starting point for A/B experiments
})
</script>
